import React, { Component } from 'react';
import Loader from 'react-loader';
import moment from 'moment/moment';

export default class CurriculumModal extends Component {
  componentDidMount() {
    this.props.getPlan(this.props.id);
  }

  render() {
    /* eslint-disable */
    const { onRequestClose, plan, isLoading } = this.props;
    return (
      <div className="plans-popup Curr-PopUp">
        <div className="close__btn" onClick={onRequestClose}>
          <div className="first" />
          <div className="second" />
        </div>
        <Loader
          color="#7b2b2a"
          loaded={!isLoading}
        >{plan
          && <div>
            <ul className="Curr-planList">
              <li className="Curr-planList__Item Curr-planList__Item_flex">Название учебного плана
                <div className="inputs__input inputs__input_ml65">
                  <input
                    type="text"
                    placeholder="Все"
                    className="input__caption"
                    value={plan.cname}
                    readOnly
                  />
                </div>
              </li>
              <li className="Curr-planList__Item Curr-planList__Item_flex">Военная специальность <br/> и и рабочий учебный план
                <div className="inputs__input ">
                  <input
                    type="text"
                    placeholder="Все"
                    className="input__caption"
                    value={plan.shortname}
                    readOnly
                  />
                </div>
              </li>
              <li className="Curr-planList__Item">{plan.cathedra}</li>
              <li className="Curr-planList__Item">ФГОС ВО №{plan.fgosnum} от {moment(plan.fgosdate).format('DD.MM.YYYY')}</li>
              <li className="Curr-planList__Item">Рабочий учебный план №{plan.plannum} от {moment(plan.plandate).format('DD.MM.YYYY')}</li>
              <li className="Curr-planList__Item ">{'Трудоёмкость, 1 ЗЕ, часов '}
                <input
                  type="text"
                  placeholder="Все"
                  className="Curr-planList__inputHours"
                  value={plan.intensity_unit_hrs}
                  readOnly
                />
              </li>
              <li className="Curr-planList__Item Curr-planList__Item_mt">Год набора</li>
            </ul>



            <table className="Curr-YearTable">
              <tr>
                <th className="table-title">№</th>
                <th className="table-title">Год набора</th>
              </tr>
              <tr>
                <td className="table-center"><input type="checkbox" /></td>
                <td className="Curr-YearTable__td_pl">Набор 2017-2018 года</td>
              </tr>
              <tr>
                <td className="table-center"><input type="checkbox" /></td>
                <td className="Curr-YearTable__td_pl">Набор 2016-2017 года</td>
              </tr>
              <tr>
                <td className="table-center"><input type="checkbox" /></td>
                <td className="Curr-YearTable__td_pl">Набор 2015-2016 года</td>
              </tr>
              <tr>
                <td className="table-center"><input type="checkbox" /></td>
                <td className="Curr-YearTable__td_pl">Набор 2014-2015 года</td>
              </tr>
              <tr>
                <td className="table-center"><input type="checkbox" /></td>
                <td className="Curr-YearTable__td_pl">Набор 2013-2014 года</td>
              </tr>
              <tr>
                <td className="table-center"><input type="checkbox" /></td>
                <td className="Curr-YearTable__td_pl">Набор 2012-2013 года</td>
              </tr>
              <tr>
                <td className="table-center"><input type="checkbox" /></td>
                <td className="Curr-YearTable__td_pl">Набор 2011-2012 года</td>
              </tr>
              <tr>
                <td className="table-center"><input type="checkbox" /></td>
                <td className="Curr-YearTable__td_pl">Набор 2010-2011 года</td>
              </tr>
            </table>
          </div>}
        </Loader>
      </div>
    );
  }
}
